module.exports = __webpack_public_path__ + "static/media/art-lives-here.67544f34.svg";